export const uploadImageToCloudinary = async (file ) => {
    const url = `https://api.cloudinary.com/v1_1/dz5wuduwc/image/upload`;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "jhonks_unsigned_upload");

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (response.ok) {
      return data.secure_url;
    } else {
      throw new Error(data.error.message || "Upload failed");
    }
  };